import './keySelector.scss'
import { ButtonGroup, Button, Select, Option } from '@mui/joy'
import { useMediaQuery } from '@mui/material'
import { MUSICAL_KEYS } from '../../data/keys'
import { useState, useEffect } from 'react'
import { getUniqueRoots, getUniqueTypes } from '../../utils/note-key-helper'

const KeySelector = ({ selectedKey, setKey }) => {
    const uniqueTypes = getUniqueTypes();
    const uniqueRoots = getUniqueRoots();
    const isMobile = useMediaQuery('(max-width: 768px)');

    const [selectedRoot, setSelectedRoot] = useState(uniqueRoots[0]);
    const [selectedType, setSelectedType] = useState(uniqueTypes[0]);

    useEffect(() => {
        const selectedKey = MUSICAL_KEYS.find(key => key.root === selectedRoot && key.type === selectedType);
        setKey(selectedKey);
    }, [selectedRoot, selectedType]);


    const renderDesktop = () => (
        <>
            <ButtonGroup>
                {uniqueRoots.map((root) => (
                    <Button
                        key={root}
                        variant={selectedKey.root === root ? 'solid' : 'outlined'}
                        onClick={() => setSelectedRoot(root)}
                    >{root}</Button>
                ))}
            </ButtonGroup>
            <ButtonGroup>
                {uniqueTypes.slice(0,7).map((type) => (
                    <Button
                        key={type}
                        variant={selectedKey.type === type ? 'solid' : 'outlined'}
                        onClick={() => setSelectedType(type)}
                    >{type}</Button>
                ))}
            </ButtonGroup>
            <ButtonGroup>
                {uniqueTypes.slice(7).map((type) => (
                    <Button
                        key={type}
                        variant={selectedKey.type === type ? 'solid' : 'outlined'}
                        onClick={() => setSelectedType(type)}
                    >{type}</Button>
                ))}
            </ButtonGroup>
        </>
    );

    // Mobile layout (dropdowns)
    const renderMobile = () => (
        <div className="mobile-selects">
            <Select
                value={selectedRoot}
                onChange={(_, newValue) => setSelectedRoot(newValue)}
                placeholder="Select Root Note"
                slotProps={{
                    button: {
                        'aria-label': 'Select root note'
                    }
                }}
            >
                {uniqueRoots.map((root) => (
                    <Option key={root} value={root}>
                        {root}
                    </Option>
                ))}
            </Select>
            <Select
                value={selectedType}
                onChange={(_, newValue) => setSelectedType(newValue)}
                placeholder="Select Scale Type"
                slotProps={{
                    button: {
                        'aria-label': 'Select scale type'
                    }
                }}
            >
                {uniqueTypes.map((type) => (
                    <Option key={type} value={type}>
                        {type}
                    </Option>
                ))}
            </Select>
        </div>
    );

    return (
        <div className='key-selector'>
            {isMobile ? renderMobile() : renderDesktop()}
        </div>
    );
}

export default KeySelector